import React from 'react';
import FormErrors from "./form_errors";
import {_t} from "../../../js/app/common/utils/locale";

export default class FormPhone extends React.Component {

    render() {
        return (
            <div className="cluster__form-group">
                <div className="form-group">
                    <label className={'label ' + (this.props.labelClass)} htmlFor={this.props.name}>{_t(this.props.label)}</label>
                    <div className={'input-group ' + (this.props.errors ? 'is-invalid' : '')}>
                        <div className="input-group-prepend">
                            <span className="input-group-text" id="validatedInputGroupPrepend">+</span>
                        </div>
                        <input
                            type="text"
                            className={'form-control input ' + (this.props.errors ? 'is-invalid' : '')}
                            id={this.props.name}
                            name={this.props.name}
                            disabled={this.props.disabled}
                            placeholder={_t((this.props.placeholder ? this.props.placeholder : this.props.label))}
                            required={this.props.required ? 'required' : ''}
                            onChange={this.props.onChange}
                            defaultValue={this.props.value}
                        />
                    </div>
                    <FormErrors errors={this.props.errors} />
                </div>
            </div>
        );
    }

}